<template>
  <div
    class="baseLayout"
  >
    <component
      :is="{...state.layout}"
    >
      <slot/>
    </component>

    <div/>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, onMounted, onUnmounted, reactive } from 'vue'
import { useRoute } from 'vue-router'

import { iosTelegramFix } from '@/appType/telegram/iosTelegramFix.js'
import { useKeepInputAboveKeyboard } from '@/hooks/useKeepInputAboveKeyboard.js'
import EmptyHomeLayout from '@/layouts/EmptyHomeLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import HomeLayout from '@/layouts/HomeLayout.vue'

const route = useRoute()

const layouts = {
  EmptyHomeLayout,
  HomeLayout,
  EmptyLayout,
}

const state = reactive({
  layout: EmptyLayout,
})

/** Profile edit forms (incl. checklist) — keep focused inputs above soft keyboard. */
const keepInputAboveKeyboard = computed(() => {
  const path = route.path || ''
  return /\/profile\/edit(\/|$)/.test(path) || /\/profile\/checklist\/.+/.test(path)
})

useKeepInputAboveKeyboard({ enabled: keepInputAboveKeyboard })

// todo: remove it
function checkKeyboardState() {
  let startFrame = window.startFrame ?? 10
  let framesCount = window.countFrames ?? 30
  let frames = framesCount
  let num = 0

  function changeHeight() {
    frames--
    if(frames) {
      requestAnimationFrame(changeHeight)
    }
    if(framesCount - frames < startFrame) {
      return
    }
    num++
    if (num % 2 === 1) {
      document.documentElement.style.setProperty('--document-height', `calc(100svh + 1px)`)
      document.documentElement.style.setProperty('--document-offset-bottom', `1px`)
    } else {
      document.documentElement.style.setProperty('--document-height', `calc(100svh + 0px)`)
      document.documentElement.style.setProperty('--document-offset-bottom', `0px`)
    }
  }

  requestAnimationFrame(changeHeight)
}

onMounted(() => {
  if (iosTelegramFix.isActive) {
    window.visualViewport.addEventListener('resize', checkKeyboardState)
  }
})
onUnmounted(() => {
  if (iosTelegramFix.isActive) {
    window.visualViewport.removeEventListener('resize', checkKeyboardState)
  }
})
// end

onBeforeMount(() => {
  state.layout = layouts[route.meta.layout]
  if (!state.layout) {
    state.layout = EmptyLayout
  }
})

</script>

<style lang="scss" scoped>

.baseLayout {
  // test
  //min-height: calc(100vh - 80px);
  //min-height: calc(100svh - 80px);
  //max-height: calc(100vh - 80px);
  //max-height: calc(100svh - 80px);

  //max-height: 100svh;
  //min-height: 100svh;

  padding-bottom: var(--document-offset-bottom);

  max-height: var(--document-height);
  min-height: var(--document-height);

  display: flex;
  flex-direction: column;
  overflow: auto;
}
</style>
